import { MapPin } from 'lucide-react'
import type { ReactNode } from 'react'
import type { DashboardUserProfile } from '@services/firebase'
import { getProfileFullName } from '@features/profile/shared/profile-helpers'
import '../profile-layout.css'

export function ProfileAccountBanner({
  addon,
  profile,
}: {
  readonly addon?: ReactNode
  readonly profile: DashboardUserProfile
}) {
  const fullName = getProfileFullName(profile)
  const location = [profile.region, profile.country]
    .filter((value): value is string => Boolean(value && value.trim()))
    .join(', ')

  return (
    <div className="profileBanner profileBannerCard">
      <span className="profileAvatar profileAvatarBanner">
        {profile.imageUrl ? (
          <img alt="" className="profileAvatarImage" src={profile.imageUrl} />
        ) : (
          fullName.charAt(0)
        )}
      </span>

      <div className="profileBannerText">
        <div className="profileBannerNameRow">
          <h1 className="profileName">{fullName}</h1>
        </div>

        {location ? (
          <div className="profileInlineRow">
            <MapPin
              aria-hidden="true"
              color="var(--lms-color-ink-muted)"
              size={24}
              strokeWidth={2.2}
            />
            <p className="profileMutedText">{location}</p>
          </div>
        ) : null}
      </div>

      {addon ? <div className="profileBannerAddon">{addon}</div> : null}
    </div>
  )
}
